import React from "react";
import { LOGOS } from "@/data/constants";

// Rotating GS emblem (transparent) — 3D coin-flip on the Y axis (kis-plus style)
export function LogoEmblem({ size = 200, spin = false, className = "" }) {
  return (
    <div
      className={`spin3d-wrap relative ${className}`}
      style={{ width: size, height: size }}
      data-testid="logo-emblem"
    >
      {spin && (
        <div
          className="absolute inset-[-18%] rounded-full"
          style={{
            background:
              "radial-gradient(circle, rgba(201,162,39,0.16) 0%, rgba(8,44,58,0.10) 42%, transparent 72%)",
          }}
        />
      )}
      <img
        src={LOGOS.emblem}
        alt="Goldstone Sourcing"
        className={`relative h-full w-full object-contain ${spin ? "spin3d" : ""}`}
        style={{ filter: "drop-shadow(0 0 26px rgba(201,162,39,0.22))" }}
      />
    </div>
  );
}

// Horizontal lockup for nav — rotating emblem + full wordmark image
export function LogoMark({ className = "", emblemSize = 46, wordmarkClass = "h-6" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="logo-mark">
      <LogoEmblem size={emblemSize} spin />
      <img src={LOGOS.wordmark} alt="Goldstone Sourcing" className={`${wordmarkClass} w-auto object-contain`} />
    </div>
  );
}
